module.exports = __webpack_public_path__ + "img/premiere_logo.8c960e97.png";